var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _vm._l(_vm.fields.ticketGroups, function (ticketGroup, ticketGroupIndex) {
        return _c(
          "v-card",
          { key: ticketGroup.id, staticClass: "mb-5" },
          [
            _c(
              "v-container",
              [
                _c(
                  "v-card-title",
                  { staticClass: "d-flex flex-row justify-lg-space-between" },
                  [
                    _vm._v(
                      ' Группа билетов "' +
                        _vm._s(ticketGroup.title || ticketGroupIndex + 1) +
                        '" '
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: { disabled: _vm.isOnlyEdit, icon: "" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteTicketGroup(
                              ticketGroup.id,
                              ticketGroupIndex
                            )
                          },
                        },
                      },
                      [
                        _c("v-icon", { attrs: { color: "red" } }, [
                          _vm._v("mdi-trash-can-outline"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-card-text",
                  {
                    staticClass:
                      "primary-form__item is-multiple-controls size-1x1x1x",
                  },
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("span", [_vm._v("Название*")]),
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                placeholder: "Группа билетов 1",
                                disabled: _vm.loading || _vm.isOnlyEdit,
                                loading: _vm.loading,
                              },
                              model: {
                                value: ticketGroup.title,
                                callback: function ($$v) {
                                  _vm.$set(ticketGroup, "title", $$v)
                                },
                                expression: "ticketGroup.title",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("span", [_vm._v("Цена*")]),
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                placeholder: "0 ₽",
                                disabled: _vm.loading || _vm.isOnlyEdit,
                                loading: _vm.loading,
                              },
                              model: {
                                value: ticketGroup.price,
                                callback: function ($$v) {
                                  _vm.$set(ticketGroup, "price", _vm._n($$v))
                                },
                                expression: "ticketGroup.price",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("span", [_vm._v("Количество*")]),
                            _c("v-text-field", {
                              attrs: {
                                outlined: "",
                                type: "number",
                                placeholder: "100",
                                disabled: _vm.loading || _vm.isOnlyEdit,
                                loading: _vm.loading,
                              },
                              model: {
                                value: ticketGroup.quantity,
                                callback: function ($$v) {
                                  _vm.$set(ticketGroup, "quantity", _vm._n($$v))
                                },
                                expression: "ticketGroup.quantity",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "4" } },
                          [
                            _c("span", [_vm._v("Зависимость от времени")]),
                            _c("v-switch", {
                              attrs: { disabled: _vm.isOnlyEdit },
                              model: {
                                value: ticketGroup.scheduleDependant,
                                callback: function ($$v) {
                                  _vm.$set(
                                    ticketGroup,
                                    "scheduleDependant",
                                    $$v
                                  )
                                },
                                expression: "ticketGroup.scheduleDependant",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            ticketGroup.scheduleDependant
                              ? [
                                  !_vm.getEventSchedulesLength
                                    ? _c("span", [_vm._v("Нет расписаний")])
                                    : _vm.eventSchedules
                                    ? _vm._l(
                                        _vm.eventSchedules,
                                        function (schedule) {
                                          return _c("v-checkbox", {
                                            key: schedule.id,
                                            staticClass: "mr-1",
                                            attrs: {
                                              disabled: _vm.isOnlyEdit,
                                              label: String(schedule.name),
                                              value: schedule.id,
                                              multiple: "",
                                            },
                                            model: {
                                              value: ticketGroup.schedules,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  ticketGroup,
                                                  "schedules",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ticketGroup.schedules",
                                            },
                                          })
                                        }
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      [
                        _c("v-col", { attrs: { cols: "4" } }, [
                          _c(
                            "span",
                            [
                              _vm._v(" Зависимость от мест "),
                              _c("v-switch", {
                                attrs: { disabled: _vm.isOnlyEdit },
                                model: {
                                  value: ticketGroup.seatingDependant,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      ticketGroup,
                                      "seatingDependant",
                                      $$v
                                    )
                                  },
                                  expression: "ticketGroup.seatingDependant",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            ticketGroup.seatingDependant
                              ? [
                                  !!_vm.getEventSeatZones
                                    ? _c("span", [_vm._v("Нет мест")])
                                    : _vm.eventSeatZones
                                    ? _vm._l(
                                        _vm.eventSeatZones,
                                        function (seatZone) {
                                          return _c("v-checkbox", {
                                            key: seatZone.id,
                                            staticClass: "mr-1",
                                            attrs: {
                                              disabled: _vm.isOnlyEdit,
                                              label: seatZone.title,
                                              value: seatZone.id,
                                              multiple: "",
                                            },
                                            model: {
                                              value: ticketGroup.seatZones,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  ticketGroup,
                                                  "seatZones",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "ticketGroup.seatZones",
                                            },
                                          })
                                        }
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.getEventSchedulesLength && !_vm.fields.ticketGroups.length
                  ? _c("div", [_c("div", [_vm._v("Билетов нет")])])
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "v-card-actions",
        [
          _c(
            "v-btn",
            {
              staticClass: "primary-form__add-section-btn",
              attrs: {
                secondary: "",
                "size-big": "",
                disabled: !_vm.eventSchedules || _vm.isOnlyEdit,
              },
              on: { click: _vm.createTicketGroup },
            },
            [_vm._v(" Добавить билеты ")]
          ),
        ],
        1
      ),
      !_vm.eventSchedules
        ? _c("ErrorMessage", {
            attrs: { message: "Необходимо хотя бы одно расписание" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }